module.exports = __webpack_public_path__ + "static/media/star-of-david.ae45aca1.svg";